import _ from 'lodash';
import ReactDOM from 'react-dom';

import {React, component, classnames} from './component';
import Indicator from './Indicator';
import Link from './Link';
import {Close, ArrowRight} from './icons';


import HtmlContent from './HtmlContent';

const pfx = ["webkit", "moz", "MS", "o", ""];

function PrefixedEvent(element, type, callback) {
  for (var p = 0; p < pfx.length; p++) {
    if (!pfx[p]) {
      type = type.toLowerCase();
    }
    element.addEventListener(pfx[p]+type, callback, false);
  }
}

const ModalLink = component('ModalLink', function({name, query, params, text, close}) {
  return (
    <div className="ModalAlert-LinkWrap">
      <Link onClick={close} className="ModalAlert-Link" query={query} name={name} params={params}>{text}</Link>
      <ArrowRight className="ModalAlert-Arrow" />
    </div>
  )
});

const ICON_SIZE = 120;

export default class ModalAlert extends React.Component {

  static propTypes = {
    message: React.PropTypes.string,
    component: React.PropTypes.element,
    action: React.PropTypes.string,
    autoClose: React.PropTypes.bool,
    onAction: React.PropTypes.func,
    onClose: React.PropTypes.func,
    close: React.PropTypes.bool,
    autoWidth: React.PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      closing: false,
      hidden: false,
      progress: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.close && nextProps.close) {
      this.close();
    }
  }

  close() {
    this.setState({
      closing: true
    });
    PrefixedEvent(ReactDOM.findDOMNode(this.refs.content), 'AnimationEnd', this.onCloseAnimationEnd.bind(this));
  }

  onCloseAnimationEnd() {
    this.setState({
      hidden: true
    });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  async onAction() {
    if (this.props.onAction) {
      const result = this.props.onAction();
      if (result && typeof result.then === 'function') {
        this.setState({
          progress: true
        });
        await result;
        if (!this.props.autoClose) {
          this.setState({
            progress: false
          });
        }
      }
    }
    if (this.props.autoClose) {
      this.close();
    }
  }

  onWheel(e) {
    e.preventDefault();
  }

  renderIcon() {
    if (this.props.icon) {
      return React.createElement(this.props.icon, {
        className: 'ModalAlert-Icon',
        width: this.props.iconWidth || ICON_SIZE,
        height: this.props.iconHeight || ICON_SIZE
      });
    }
  }

  renderMessage() {
    if (_.isString(this.props.message)) {
      return <HtmlContent className='ModalAlert-Message' html={this.props.message} />;
    }
  }

  renderLinks() {
    if (this.props.links) {
      const closeMethod = this.close.bind(this);

      const links = this.props.links.map((props)=>(
        <ModalLink close={closeMethod} {...props} />
      ));

      return links;
    }
  }

  renderActionButton() {
    if (this.props.action) {
      const actionClassName = classnames(
        'ModalAlert-Action',
        {
          'ModalAlert-Action--Progress': this.state.progress
        }
      );
      return (
        <div className={actionClassName} onClick={this.onAction.bind(this)}>
          {this.state.progress && <Indicator className='ModalAlert-Indicator' />}
          {this.props.action}
        </div>
      );
    }
  }

  render() {

    const alertClassName = classnames(
      'ModalAlert',
      this.props.autoWidth && 'ModalAlert--AutoWidth',
      {
        'ModalAlert--Closing': this.state.closing,
        'ModalAlert--Hidden': this.state.hidden
      }
    );

    const contentClassName = classnames(
      'ModalAlert-Content',
      {
        'ModalAlert-Content--Closing': this.state.closing,
        'ModalAlert-Content--Hidden': this.state.hidden
      }
    );

    return (
      <div className={alertClassName}  onWheel={this.onWheel.bind(this)}>
        <div onClick={this.close.bind(this)} className="ModalAlert--Background"></div>
        <div className={contentClassName} ref='content'>
          <div className='ModalAlert-Close' onClick={this.close.bind(this)}>
            <Close className='ModalAlert-CloseIcon' />
          </div>
          {this.renderIcon()}
          {this.renderMessage()}
          {this.renderLinks()}
          {this.renderActionButton()}
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/ModalAlert.js